import { Show } from "solid-js";
import type { ValueDefinition } from "@tailor-frame/engine";

/** One editable value: label, number input and slider, used for measurements and style options. */
export function MeasureRow(props: { id: string; definition: ValueDefinition; value: number; active: boolean; onActive: (id: string | undefined) => void; onChange: (id: string, value: number) => void }) {
  const change = (value: number) => { if (Number.isFinite(value)) props.onChange(props.id, value); };
  const step = () => props.definition.type === "integer" ? 1 : props.definition.type === "length" ? 1 : 0.1;
  const unit = () => props.definition.type === "length" ? "mm" : "";
  return (
    <div class="measure-row" classList={{ active: props.active }} onMouseEnter={() => props.onActive(props.id)} onMouseLeave={() => props.onActive(undefined)} onFocusIn={() => props.onActive(props.id)} onFocusOut={() => props.onActive(undefined)}>
      <label for={`measure-${props.id}`}>{props.definition.label}</label>
      <div class="measure-value">
        <input id={`measure-${props.id}`} type="number" min={props.definition.minimum} max={props.definition.maximum} step={step()} value={props.value} onInput={(event) => change(event.currentTarget.valueAsNumber)} />
        <small>{unit()}</small>
      </div>
      <input class="measure-slider" type="range" aria-label={`${props.definition.label} slider`} min={props.definition.minimum} max={props.definition.maximum} step={step()} value={props.value} onInput={(event) => change(event.currentTarget.valueAsNumber)} />
      <Show when={props.definition.minimum !== undefined && props.definition.maximum !== undefined}>
        <small class="measure-range">{props.definition.minimum}–{props.definition.maximum} {unit()}</small>
      </Show>
    </div>
  );
}
